module.exports = __webpack_public_path__ + "img/conteudos_casas_construcao_15.411c1fc7.png";